import { classOf, classSkills } from "@eldrun/content";

export interface SkillSlotView {
  id: string;
  name: string;
  description: string;
  /** Tecla (rótulo), vazia na passiva. */
  key: string;
  /** Fração da recarga que falta (1 = acabou de usar, 0 = pronta). */
  cooldown: number;
  /** Segundos que faltam (arredondado para cima), 0 se pronta. */
  seconds: number;
  ready: boolean;
  /** Ultimate sem a carga (F67) ou bloqueada. */
  locked: boolean;
}

export interface SkillBarView {
  className: string;
  passiva: SkillSlotView;
  ativa: SkillSlotView;
  ultimate: SkillSlotView;
}

/**
 * Barra de habilidades (F65, doc 09 §5.2): a passiva, a ativa com a recarga (contada no cliente a
 * partir da resposta do servidor, que é quem decide) e a ultimate (carga na F67). Projeção pura.
 */
export function skillBarView(classId: string, readyAt: number, now: number, keys: { ativa: string; ultimate: string }, ultimateCharge = 0): SkillBarView {
  const c = classOf(classId);
  const s = classSkills(c);
  const left = Math.max(0, readyAt - now);
  const total = s.ativa.cooldownMs ?? 1;
  const base = (k: typeof s.passiva) => ({ id: k.id, name: k.name, description: k.description });
  return {
    className: c.name,
    passiva: { ...base(s.passiva), key: "", cooldown: 0, seconds: 0, ready: true, locked: false },
    ativa: { ...base(s.ativa), key: keys.ativa, cooldown: Math.min(1, left / total), seconds: Math.ceil(left / 1000), ready: left <= 0, locked: false },
    ultimate: { ...base(s.ultimate), key: keys.ultimate, cooldown: 1 - Math.min(1, ultimateCharge / 100), seconds: 0, ready: ultimateCharge >= 100, locked: ultimateCharge < 100 },
  };
}
